import React from 'react';
import PropTypes from 'prop-types';
import { Translate } from 'core/translate';

const ModalImage = ({ url, alt, showImageDisclosure }) => {
  if (!url) {
    return null;
  }

  return (
    <div className="modal-body__image-container">
      <img src={url} alt={alt} className="modal__image" />
      {showImageDisclosure && (
        <div className="modal-body__image-disclosure">
          <Translate value="images.for.illustrative.v3" />
        </div>
      )}
    </div>
  );
};

ModalImage.propTypes = {
  url: PropTypes.string,
  alt: PropTypes.string.isRequired,
  showImageDisclosure: PropTypes.bool,
};

export default ModalImage;
